import { render } from "./DatabaseVersion101.vue?vue&type=template&id=680379e4&scoped=true"
import script from "./DatabaseVersion101.vue?vue&type=script&lang=js"
export * from "./DatabaseVersion101.vue?vue&type=script&lang=js"

import "./DatabaseVersion101.vue?vue&type=style&index=0&id=680379e4&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-680379e4"]])

export default __exports__